module.exports = __webpack_public_path__ + "static/img/cooperation15.ce52306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/cooperation15.png
// module id = +sJm
// module chunks = 0